import { useIsSofi } from '../cobranded/useIsSofi'

const CONSTANTS = {
  LEGAL_BANNER_EXPERIMENT_KEY: 'legal-banner-experiment',
  variation: 'variant_1',
}

export const usePolicyBanner = () => {
  const isSofi = useIsSofi()

  return {
    isEnabled: !isSofi,
    constants: CONSTANTS,
  }
}
